import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import {
  loggedInIHAdminData,
  loggedInPatientData,
  loggedInOrgAdminData,
  loggedInProviderData,
  createPass,
  createPassToken,
  resetToken,
  changeEmailToken,
  changeEmail,
  resendInvitationToken,
  codeError,
  codeSuccess,
  backupCodes,
} from '../mockData/authentication-data';

const AuthenticationApi = [
  rest.post(`${API_ROOT}authentication`, (req, res, ctx) => {
    const { email } = req.body;
    if (email === 'ann+00@tidepoollabs.com') {
      return res(ctx.json(loggedInOrgAdminData));
    }
    if (email === 'ann+16@tidepoollabs.com') {
      return res(ctx.json(loggedInProviderData(true)));
    }
    if (email === 'example@bmiq.com') {
      return res(ctx.json(loggedInIHAdminData));
    }
    return res(ctx.json(loggedInPatientData));
  }),
  rest.post(`${API_ROOT}check-authentication`, (req, res, ctx) => res(ctx.json({ isIdle: false }))),
  rest.post(`${API_ROOT}authmanagement`, (req, res, ctx) => {
    const action = req.url.searchParams.get('action');
    if (action === 'passwordChange') {
      return res(ctx.json({ ...loggedInPatientData, passwordLastUpdate: '2021-06-23T16:27:16.306Z' }));
    }
    return res(ctx.json(loggedInPatientData));
  }),

  rest.post(`${API_ROOT}refresh-auth`, (req, res, ctx) => res(ctx.json(loggedInPatientData))),
  rest.get(`${API_ROOT}activate-account/${createPassToken}`, (req, res, ctx) => res(ctx.json(createPass))),
  rest.get(`${API_ROOT}activate-account/${changeEmailToken}`, (req, res, ctx) => res(ctx.json(changeEmail))),
  rest.get(`${API_ROOT}activate-account/${resendInvitationToken}`, (req, res, ctx) => res(ctx.json({ action: 'invite' }))),
  rest.get(`${API_ROOT}activate-account/${resetToken}`, (req, res, ctx) => res(ctx.json(createPass.email))),
  rest.post(`${API_ROOT}two-factor-authentication`, (req, res, ctx) => res(ctx.json())),
  rest.put(`${API_ROOT}two-factor-authentication/${codeError}`, (req, res) => res(new Error())),
  rest.put(`${API_ROOT}two-factor-authentication/${codeSuccess}`, (req, res, ctx) => res(ctx.json({ success: true }))),
  rest.patch(`${API_ROOT}two-factor-authentication`, (req, res, ctx) => res(ctx.json(backupCodes))),
];
export default AuthenticationApi;
